import { render, staticRenderFns } from "./OrderReturnDetailModal.vue?vue&type=template&id=80e27036&"
import script from "./OrderReturnDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderReturnDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderReturnDetailModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports